import { useEffect, useRef } from "react";
import moment from "moment";

const useRealSpots = (campaign, deps) => {
  const { getSingleReportRequest, reportSingleData, loadingSingleReport } = deps;
  const requestedFor = useRef(null);

  const campaignId = campaign && campaign.id;

  useEffect(() => {
    if (!campaignId || requestedFor.current === campaignId) return;
    const contentsDisplays = campaign.contents_displays || [];
    if (contentsDisplays.length === 0) return;

    requestedFor.current = campaignId;
    const displays = contentsDisplays.map((d) => d.display_id).join(",");
    const contents = contentsDisplays.map((d) => d.content_id).join(",");

    getSingleReportRequest({
      campaign: campaignId,
      displays,
      contents,
      from_date: moment(campaign.start_date).format("YYYY-MM-DD"),
      to_date: moment(campaign.end_date).format("YYYY-MM-DD"),
      is_campaign: 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId]);

  if (
    requestedFor.current !== campaignId ||
    loadingSingleReport ||
    !reportSingleData ||
    !reportSingleData.report ||
    reportSingleData.report.length === 0
  ) {
    return null;
  }

  return reportSingleData.report.reduce((acc, d) => acc + (d.shows || 0), 0);
};

export default useRealSpots;
